import React, { Fragment, useEffect } from "react";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import AtomTestnet from "../../components/AtomDashboard/AtomTestnet";

const AtomTestnetPage: React.FC = () => {
  useEffect(() => {
    document.title = "Atom Testnet Dashboard | Atom Foundation";
  }, []);

  return (
    <Fragment>
      <div className="lab-page inner-page">
        <div className="body_wrap o-clip">
          <main>
            <AtomTestnet />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default AtomTestnetPage;
